<template>
    <div>
        <proj-header :page-name="headerText" :has-add="hasAddBtn" @add="addProj"></proj-header>
        <!-- 検索 -->
        <find-input ref="search"></find-input>

        <!-- リスト -->
        <act-list 
            v-show="showList"
            ref="list"
            :has-header="false"
            mt>
            <div v-if="getListObj">
                <div v-if="getListObj.data.length > 0">
                    <div class="py-1" v-for="item in getListObj.data" :key="item.id">
                        <row :item="item" :class="{'selected-proj':selectedProj == item.id}"></row>
                    </div>
                </div>
            </div>
        </act-list>
        <!-- メニュー -->
        <proj-menu ref="menu"></proj-menu>
        <!-- シェア -->
        <proj-share ref="share"></proj-share>
        <!-- 単価 -->
        <price-set ref="price"></price-set>
        <!-- 備考 -->
        <note ref="note"></note>
        <!-- メッセージ -->
        <info-msg ref="msg" :lev="lev" :msg="msg" @ok="msgOk"></info-msg>

    </div>
</template>

<script>
    import ProjHeader from 'pages/commons/header/Header'
    import ActList from 'pages/commons/List/List'
    import ProjMenu from './components/Menu'
    import ProjShare from 'pages/commons/projShare/ProjShare'
    import InfoMsg from 'pages/commons/modal/infoMsg/InfoMsg'
    import PriceSet from './components/Price'
    import Note from './components/Note'
    import Row from './components/Row'
    import FindInput from './components/Input'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            ProjHeader,
            ActList,
            ProjMenu,
            ProjShare,
            PriceSet,
            Note,
            InfoMsg,
            Row,
            FindInput
        },
        data () {
            return {
                // info msg 用
                lev: 0,
                msg: "",
                msgKey: "",
                selectId: "",
                selectedProj: "",
                hasAddBtn: false,
                showList: true,
                optAll:false
            }
        },
        mounted () {
            this.loadListData(this.$refs.search.getSearchItems())
            this.$refs.list.resetRefresh('cmpActProjs')
            this.setBtn()
        },
        activated () {
            if (this.getRefreshArr['cmpActProjs']) {
                // homeから来る時、検索条件などリセット
                this.resetThis()
            }
            this.$refs.list.isGetList('cmpActProjs',{ 
                    url:'cmp.projs.act',
                    data: this.$refs.search.getSearchItems()
                })
            this.$refs.list.resetRefresh('cmpActProjs')
            this.setBtn()
        },
        watch: {
            $route (to, from) {
                this.getSelectedProjLocal()
            },
            async getCmpProjDelStatus (status) {
                if (status == 0) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    await this.refreshPage()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            },
            async getChangeCmpProjInfoCommonStatus (status) {
                if (status == 0) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    await this.refreshPage()
                    this.openMsgS('更新しました。')
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            },
            async getSendMailComStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    await this.refreshPage()
                    this.$store.dispatch('doneSpinner')
                    // 結果メッセージ表示
                    this.openMsgS(this.getSendMailComRes.sendCntMb + '案件、' + this.getSendMailComRes.sendCnt + '件送信完了。')
                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            headerText () {
                if (this.$route.params.do == 'waiting') {
                    return '公開待ちの案件'
                }
                if (this.$route.params.do == 'timeout') {
                    return '期限過ぎた案件'
                }
                if (this.$route.params.do == 'opening') {
                    return '募集中'
                }
                if (this.$route.params.do == 'private') {
                    return '内部案件'
                }
                if (this.$route.params.do == 'closing') {
                    return '募集終了'
                }
                if (this.$route.params.do == 'delete') {
                    return '削除待ちの案件'
                }
                if (this.$route.params.do == 'accesslimit') {
                    return '閲覧制限'
                }
                return ""
            },
            ...mapGetters([ 'getListObj'
                , 'getCmpProjDelStatus'
                , 'getChangeCmpProjInfoCommonStatus'
                , 'getSendMailComStatus'
                , 'getSendMailComRes'
                , 'getRefreshArr'
            ])
        },
        methods: {
            searchProj (type='new') {
                let data = this.$refs.search.getSearchItems(type)
                this.loadListData(data)
            },
            refreshPage () {
                let data = this.$refs.search.getSearchItems('old')
                if (this.getListObj.data.length != 1) {
                    // 当該ページのラストデータを操作する場合、直接検索 skip=0
                    data.skip = this.getListObj.data.slice(-1)[0].id
                    if (this.optAll) {
                        data.refresh = '0'
                    } else {
                        data.refresh = this.getListObj.next_page_url != null ? '1':'0'
                    }
                }
                this.optAll = false
                this.loadListData(data)
            },
            loadListData (data) {
                this.$refs.list.loadListObj({
                    url:'cmp.projs.act',
                    data: data
                })
            },
            searchCompanyData (rec_user_group) {
                let data = this.$refs.search.getSearchItems()
                this.$refs.search.keyword = rec_user_group
                this.$refs.search.keyword_bk = rec_user_group
                data.key = JSON.stringify(rec_user_group)
                this.loadListData(data)
            },
            getSelectedProjLocal () {
                try {
                    this.selectedProj = localStorage.getItem('selectedProj')
                } catch(e) { }
            },
            setBtn () {
                this.hasAddBtn = this.$route.params.do == 'waiting' || this.$route.params.do == 'opening' || this.$route.params.do == 'private' ? true : false
            },
            resetThis () {
                this.selectedProj = ""
                this.$refs.search.resetThis()
            },
            addProj () {
                this.$router.push({name: 'CmpProjCreate', params:{
                    do: 'create'
                }})
            },
            projPricePub (item) {
                this.$refs.price.openThis(item)
            },
            projShare (item) {
                this.$refs.share.openThis(item)
            },
            projNote (item) {
                this.$refs.note.openThis(item)
            },
            openMsg (lev, msg, key, id='') {
                this.lev = lev
                this.msg = msg
                this.msgKey = key
                this.selectId = id
                this.$refs.msg.openThis()
            },
            openMsgS (msg, lev=0) {
                this.msg = msg
                this.lev = lev
                this.$refs.msg.openThis()
            },
            msgOk () {
                if (this.msgKey == 'delete') {
                    this.$store.dispatch('cmpProjDel', {
                        id: this.selectId,
                    })
                }
                if (this.msgKey == 'allRecentDay') {
                    this.optAll = true
                    this.$refs.search.updateAllRecentInDay()
                }
                if (this.msgKey == 'allProjOff') {
                    this.optAll = true
                    this.$refs.search.allProjOff()
                }
            },
            seeMoreMt () {
                let data = this.$refs.search.getSearchItems('old')
                data.skip = this.getListObj.data.slice(-1)[0].id

                this.$store.dispatch('loadListObjSeeMore', {
                    url:'cmp.projs.act',
                    skip: data
                })
            },
        }
    }
</script>

<style lang="stylus" scoped>
.selected-proj
    box-shadow: 0px 0px 10px 3px #4dc0b5;

.sticky-top-cust 
    position: sticky;
    top: 0;
    z-index: 1000;
</style>
